import type { JSX } from 'react';
import { MkOlingo }   from './MkOlingo';
import { MkKB }       from './MkKB';
import { MkSimTable } from './MkSimTable';
import { MkWizard }   from './MkWizard';
import { MkLegalDoc } from './MkLegalDoc';
import { MkTraffic }  from './MkTraffic';
import { MkQueue }    from './MkQueue';
import { MkLogs }     from './MkLogs';

export const MOCKUPS: Record<string, () => JSX.Element> = {
  'olingo-medical':         MkOlingo,
  'derantwortpartner':      MkKB,
  't-systems-connectivity': MkSimTable,
  'heggel-advisor':         MkWizard,
  'anywhere-legal':         MkLegalDoc,
  'eurowag-legislation':    MkTraffic,
  'rowanai':                MkQueue,
  'byteship':               MkLogs,
};
